import Splide from '@splidejs/splide';
import { setTimeout } from 'core-js';
import dJSON from 'dirty-json';

/**
 * Building the slider content
 */
(() => {
  const moduleSelector = '.hero-slider'; // Name of the div where the script is
  const modules = document.querySelectorAll(moduleSelector);
  if (!modules.length) return;

  modules.forEach((query) => {
    try {
      query.querySelector('script')?.remove(); // cleanup

      const { data } = dJSON.parse(query.data);

      data.forEach((item) => {
        query.querySelector('.slide-list').insertAdjacentHTML('beforeend', /* html */ `
          <div class="slide splide__slide">
            <div class="image-wrapper">
              <img src="${item.image}" alt="Image"/>
            </div>
            <div class="content-wrapper container">
              <div class="content">
                <p class="kicker">${item.kicker}</p>
                <h1 class="title">${item.title}</h1>
                <p class="description">${item.description}</p>
                ${item.anchor && item.link ? `
                  <a class="btn-custom primary action-link" href="${item.anchor}">
                    ${item.link}
                  </a>
                ` : ''}
              </div>
            </div>
          </div>
        `);
      });
    } catch (error) {
      console.error(`Error: ${moduleSelector}`, error);
    }
  });
})();

/**
 * Slider settings
 */
(() => {
  document.querySelectorAll('.hero-slider')
    .forEach((item) => {
      const cardAmount = item.querySelectorAll('.splide__slide').length;

      const slider = new Splide(item, {
        type: 'slide', // 'slide', 'loop' or 'fade'
        rewind: true, // go back to the first slide after the last
        perPage: 1, // how many items to show
        perMove: 1, // how many items to show when clicking next/prev
        gap: 0, // space between items
        pagination: cardAmount > 1, // show dots
        arrows: cardAmount > 1, // show arrows
        autoplay: true, // turn it on
        setInterval: 5000, // time between slides
        drag: cardAmount > 1, // disable drag if all slides are visible
      });
      slider.mount();
    });

  setTimeout(() => {
    window.dispatchEvent(new Event('resize'));
  }, 500);
})();
